import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, isRef as _isRef } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "tilanimike-cell"
}
const _hoisted_2 = { class: "tilat-column" }
const _hoisted_3 = { class: "tilat-display gap-2" }

import ComCancelIconButton from "@/components/common/buttons/ComCancelIconButton.vue"
import ComMinusButton from "@/components/common/buttons/ComMinusButton.vue"
import ComPlusButton from "@/components/common/buttons/ComPlusButton.vue"
import ComSaveButton from "@/components/common/buttons/ComSaveButton.vue"
import ComKommentointi from "@/components/kommentointi/ComKommentointi.vue"
import ComStatus from "../ComStatus.vue"
import { Paperclip, Warning } from "@element-plus/icons-vue"
import ComMoreButton from "@/components/common/buttons/ComMoreButton.vue"
import ComMallihuonekorttiEditToimintaDialog from "@/components/hanke/huonekortit/table/ComMallihuonekorttiEditToimintaDialog.vue"
import { huonekorttiTableEditable } from "./huonekorttiTableEditable"
import { ref } from "vue"
import ComCommentButton from "@/components/common/buttons/ComCommentButton.vue"
import ComHuonekorttiExpandedRow from "./ComHuonekorttiExpandedRow.vue"
import { useTilatunnusValidation } from "@/methods/tilatunnusValidationComposables"
import { useHuonekorttiTableWithDuplicates, useHuonekorttiExpansion } from "./huonekorttiTable"
import { hankePage } from "@/views/hanke"
import { TilaResponse } from "@/api/models/tila-response"
import { HuonekorttiResponse } from "@/api/models/huonekortti-response"
import { HuonekorttiRequestPut } from "@/api/models/huonekortti-request-put"


export default /*@__PURE__*/_defineComponent({
  __name: 'ComHuonekorttiTableEditable',
  setup(__props) {

const viite = ref()
const showDrawer = ref(false)
const {
    huonekortit,
    mallihuonekortti,
    mallihuonekorttiDialog,
    tilanimikkeet,
    edit,
    editedHuonekortti,
    paakayttaja,
    writableVastuuyksikot,
    tableRef,
    kommentitCount,
    sortChanged,
    removeTila,
    addTila,
    cancelEdit,
    saveEdit,
    editHuonekortti,
    addMallihuonekorttiClick,
    checkPoistoOikeus,
    deleteHuonekorttiClick,
    getKommentitCount,
    getLiitteetCount
} = huonekorttiTableEditable()

const { id: hankeId } = hankePage()
const { validateTilatunnus, showDuplicateConfirmation } = useTilatunnusValidation()
const { isDuplicateTilatunnus, isDuplicateHuonekortti } = useHuonekorttiTableWithDuplicates(hankeId)
const { expandedRows, liitteet, liitteetLoading, handleRowExpand, downloadLiiteClick } = useHuonekorttiExpansion()
const validationErrors = ref<Map<string | number, string>>(new Map())

const getValidationKey = (tila: TilaResponse, index: number) => tila.id || tila.tilatunnus || `index-${index}`

const validateTilatunnusInput = async (tila: TilaResponse, tilatunnus: string | undefined, index: number) => {
    const key = getValidationKey(tila, index)
    
    if (!tilatunnus?.trim() || !hankeId.value) {
        validationErrors.value.delete(key)
        return
    }

    // Skip validation if tilatunnus hasn't changed
    const originalHuonekortti = huonekortit.value?.find(h => h.id === edit.value)
    const originalTila = originalHuonekortti?.tilat?.find(t => t.id === tila.id)
    if (originalTila?.tilatunnus === tilatunnus.trim()) {
        validationErrors.value.delete(key)
        return
    }

    try {
        const isAvailable = await validateTilatunnus(hankeId.value, tilatunnus)
        if (isAvailable) {
            validationErrors.value.delete(key)
        } else {
            validationErrors.value.set(key, "Tilatunnus on jo käytössä")
        }
    } catch (error) {
        validationErrors.value.set(key, "Validointi epäonnistui")
    }
}

const validateAllTilatunnusBeforeSave = async (huonekortti: HuonekorttiRequestPut) => {
    // Get original huonekortti to compare tilatunnus changes
    const originalHuonekortti = huonekortit.value?.find(h => h.id === edit.value)

    const validationPromises = huonekortti.tilat?.map(async (tila: TilaResponse, index: number) => {
        if (tila.tilatunnus?.trim()) {
            // Check if this tilatunnus has changed from the original
            const originalTila = originalHuonekortti?.tilat?.find(t => t.id === tila.id)
            const hasChanged = !originalTila || originalTila.tilatunnus !== tila.tilatunnus?.trim()

            // Only validate if tilatunnus has changed
            if (hasChanged) {
                await validateTilatunnusInput(tila, tila.tilatunnus, index)
            }
        }
    }) || []

    await Promise.all(validationPromises)
    return validationErrors.value.size === 0
}

const saveEditWithValidation = async (item: HuonekorttiResponse) => {
    const isValid = await validateAllTilatunnusBeforeSave(editedHuonekortti.value)
    
    if (!isValid) {
        const duplicates: string[] = []
        validationErrors.value.forEach((message, key) => {
            if (message === "Tilatunnus on jo käytössä") {
                const tila = editedHuonekortti.value.tilat?.find((t, index) => getValidationKey(t, index) === key)
                if (tila?.tilatunnus) {
                    duplicates.push(tila.tilatunnus)
                }
            }
        })
        
        const shouldContinue = await showDuplicateConfirmation(duplicates)
        if (shouldContinue) {
            saveEdit(item)
            validationErrors.value.clear()
        }
    } else {
        saveEdit(item)
        validationErrors.value.clear()
    }
}

const showHuonekorttiKommentit = (id : number) => {
    viite.value = id
    showDrawer.value = true
}


return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_table, {
      data: _unref(huonekortit),
      onSortChange: _unref(sortChanged),
      "default-sort": { prop: 'tilanimike', order: 'ascending' },
      ref_key: "tableRef",
      ref: tableRef,
      "scrollbar-always-on": true,
      "expand-row-keys": _unref(expandedRows),
      onExpandChange: _unref(handleRowExpand),
      "row-key": "id"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { type: "expand" }, {
          default: _withCtx(({ row }) => [
            _createVNode(ComHuonekorttiExpandedRow, {
              row: row,
              liitteet: _unref(liitteet),
              "liitteet-loading": _unref(liitteetLoading),
              onDownloadLiite: _unref(downloadLiiteClick)
            }, null, 8, ["row", "liitteet", "liitteet-loading", "onDownloadLiite"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Tilanimike",
          width: "180",
          sortable: "custom",
          prop: "tilanimike"
        }, {
          default: _withCtx((scope) => [
            (_unref(edit) === scope.row.id)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 0,
                  size: "small",
                  modelValue: _unref(editedHuonekortti).tilanimike.id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(editedHuonekortti).tilanimike.id) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tilanimikkeet), (tilanimike) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: tilanimike.id,
                        label: tilanimike.nimi,
                        value: tilanimike.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_router_link, {
                    to: { name: 'Huonekortti', params: { huonekorttiId: scope.row.id } },
                    custom: ""
                  }, {
                    default: _withCtx(({ href, navigate }) => [
                      _createVNode(_component_el_link, {
                        type: "primary",
                        href: href,
                        onClick: navigate
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row.tilanimike.nimi), 1)
                        ]),
                        _: 2
                      }, 1032, ["href", "onClick"])
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createVNode(_component_el_space, { size: 4 }, {
                    default: _withCtx(() => [
                      (_unref(isDuplicateHuonekortti)(scope.row))
                        ? (_openBlock(), _createBlock(_component_el_icon, {
                            key: 0,
                            color: "#e6a23c"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Warning))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _withDirectives(_createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Paperclip))
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _unref(getLiitteetCount)(scope.row.id)]
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          "min-width": "250px",
          label: "Täsmennys",
          "show-overflow-tooltip": "",
          sortable: "custom",
          prop: "tasmennys"
        }, {
          default: _withCtx((scope) => [
            (_unref(edit) === scope.row.id)
              ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 0,
                  size: "small",
                  modelValue: _unref(editedHuonekortti).toiminta,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(editedHuonekortti).toiminta) = $event))
                }, null, 8, ["modelValue"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(scope.row.toiminta), 1)
                ], 64))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Status",
          width: "120",
          sortable: "custom",
          prop: "status"
        }, {
          default: _withCtx((scope) => [
            _createVNode(ComStatus, {
              huonekortti: scope.row,
              modelValue: scope.row.status,
              "onUpdate:modelValue": ($event: any) => ((scope.row.status) = $event)
            }, null, 8, ["huonekortti", "modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          "show-overflow-tooltip": "",
          label: "Vastuuyksikkö",
          sortable: "custom",
          prop: "vastuuyksikko",
          width: "180"
        }, {
          default: _withCtx((scope) => [
            (_unref(edit) === scope.row.id)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_unref(writableVastuuyksikot))
                    ? (_openBlock(), _createBlock(_component_el_select, {
                        key: 0,
                        size: "small",
                        modelValue: _unref(editedHuonekortti).vastuuyksikko.id,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(editedHuonekortti).vastuuyksikko.id) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(writableVastuuyksikot), (vastuuyksikko) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: vastuuyksikko.id,
                              label: vastuuyksikko.nimi,
                              value: vastuuyksikko.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(scope.row.vastuuyksikko.nimi), 1)
                ], 64))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "tilat",
          label: "Tilat",
          "min-width": "300"
        }, {
          default: _withCtx((scope) => [
            (_unref(edit) === scope.row.id)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_el_row, { gutter: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 10 }, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createElementVNode("label", null, "Tilatunnus", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 7 }, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createElementVNode("label", null, "Pinta-ala", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 7 }, {
                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                          _createElementVNode("label", null, null, -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(editedHuonekortti).tilat, (tila, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: tila.id
                    }, [
                      _createVNode(_component_el_row, {
                        gutter: 8,
                        class: "tilat-row"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 10 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: tila.tilatunnus,
                                "onUpdate:modelValue": ($event: any) => ((tila.tilatunnus) = $event),
                                size: "small",
                                status: validationErrors.value.has(getValidationKey(tila, index)) ? 'error' : '',
                                onBlur: ($event: any) => (validateTilatunnusInput(tila, tila.tilatunnus, index)),
                                onInput: ($event: any) => (validationErrors.value.delete(getValidationKey(tila, index))),
                                placeholder: "Tilatunnus"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "status", "onBlur", "onInput"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, { span: 7 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: tila.pintaAla,
                                "onUpdate:modelValue": ($event: any) => ((tila.pintaAla) = $event),
                                size: "small",
                                type: "number",
                                placeholder: "m2"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, { span: 7 }, {
                            default: _withCtx(() => [
                              _createVNode(ComMinusButton, {
                                onClick: ($event: any) => (_unref(removeTila)(_unref(editedHuonekortti), index))
                              }, null, 8, ["onClick"]),
                              (index + 1 === _unref(editedHuonekortti).tilat?.length)
                                ? (_openBlock(), _createBlock(ComPlusButton, {
                                    key: 0,
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(addTila)(_unref(editedHuonekortti))))
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      (validationErrors.value.has(getValidationKey(tila, index)))
                        ? (_openBlock(), _createBlock(_component_el_row, {
                            key: 0,
                            class: "tilat-row"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                span: 24,
                                class: "validation-error",
                                style: {"text-align":"left"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(validationErrors.value.get(getValidationKey(tila, index))), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ], 64))
              : (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 1,
                  disabled: _unref(edit) !== undefined,
                  placement: "top"
                }, {
                  content: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.tilat, (tila) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: tila.id
                      }, _toDisplayString(tila.tilatunnus) + " " + _toDisplayString(tila.pintaAla ? `(${tila.pintaAla} m²)` : ''), 1))
                    }), 128))
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_el_space, { size: 1 }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.tilat, (tila) => {
                              return (_openBlock(), _createBlock(_component_el_tag, {
                                key: tila.id,
                                size: "small",
                                type: _unref(isDuplicateTilatunnus)(tila.tilatunnus) ? 'warning' : 'info'
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(tila.tilatunnus), 1)
                                ]),
                                _: 2
                              }, 1032, ["type"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["disabled"]))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "lkm",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.tilat.length) + " kpl", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          width: "100",
          fixed: "right"
        }, {
          default: _withCtx((scope) => [
            (_unref(edit) === scope.row.id)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(ComCancelIconButton, {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(cancelEdit)()))
                  }),
                  _createVNode(ComSaveButton, {
                    onClick: ($event: any) => (saveEditWithValidation(scope.row))
                  }, null, 8, ["onClick"])
                ], 64))
              : _createCommentVNode("", true),
            (!_unref(edit) && _unref(kommentitCount))
              ? (_openBlock(), _createBlock(_component_el_badge, {
                  key: 1,
                  "is-dot": "",
                  hidden: !_unref(getKommentitCount)(scope.row.id),
                  class: "badge"
                }, {
                  default: _withCtx(() => [
                    _createVNode(ComCommentButton, {
                      onClick: ($event: any) => (showHuonekorttiKommentit(scope.row.id))
                    }, null, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1032, ["hidden"]))
              : _createCommentVNode("", true),
            (!_unref(edit) && _unref(writableVastuuyksikot)?.some((v) => v.id === scope.row.vastuuyksikko.id))
              ? (_openBlock(), _createBlock(_component_el_dropdown, {
                  key: 2,
                  trigger: "click"
                }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, {
                      onClick: ($event: any) => (_unref(editHuonekortti)(scope.row))
                    }, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode("Muokkaa", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]),
                    (_unref(checkPoistoOikeus)(scope.row))
                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                          key: 0,
                          onClick: ($event: any) => (_unref(deleteHuonekorttiClick)(scope.row))
                        }, {
                          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                            _createTextVNode(" Poista ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (_unref(paakayttaja))
                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                          key: 1,
                          onClick: ($event: any) => (_unref(addMallihuonekorttiClick)(scope.row))
                        }, {
                          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                            _createTextVNode(" Luo mallihuonekortti ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(ComMoreButton)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "onSortChange", "expand-row-keys", "onExpandChange"]),
    (_unref(mallihuonekortti))
      ? (_openBlock(), _createBlock(ComMallihuonekorttiEditToimintaDialog, {
          key: 0,
          dialog: _unref(mallihuonekorttiDialog),
          "onUpdate:dialog": _cache[5] || (_cache[5] = ($event: any) => (_isRef(mallihuonekorttiDialog) ? (mallihuonekorttiDialog).value = $event : null)),
          huonekortti: _unref(mallihuonekortti)
        }, null, 8, ["dialog", "huonekortti"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_drawer, {
      modelValue: showDrawer.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showDrawer).value = $event)),
      size: "50%",
      title: "Kommentointi",
      "destroy-on-close": "",
      onClose: _cache[7] || (_cache[7] = ($event: any) => (viite.value = undefined))
    }, {
      default: _withCtx(() => [
        (viite.value)
          ? (_openBlock(), _createBlock(ComKommentointi, {
              key: 0,
              paakayttaja: _unref(paakayttaja),
              viite: viite.value,
              tyyppi: 1
            }, null, 8, ["paakayttaja", "viite"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})